/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x4da8fd from'./../../message.js';class SocketDisconnectMessage extends _0x4da8fd{constructor(_0x33e7e5){super(),this['id']=_0x33e7e5;}['toJSON'](){return{'id':this['id']};}static['fromJSON'](_0x3b5730){return new SocketDisconnectMessage(_0x3b5730['id']);}}SocketDisconnectMessage['TYPE']='33',SocketDisconnectMessage['READABLE_TYPE_NAME']='disconnectSocket',SocketDisconnectMessage['DESCRIPTOR_NAME']='SocketDisconnectMessage',SocketDisconnectMessage['DESCRIPTOR']={'fields':{'id':{'type':'string','id':0x1}}};export default SocketDisconnectMessage;